import { FormItem } from '../../form';
import { FieldProps } from '../type/form';

export function FormSelect(props: FieldProps) {
  const { name, label, tip, className = 'input', inputClassName = '', required, group, rules, options = [] } = props;

  return (
    <FormItem
      {...{
        name,
        label,
        tip,
        className,
        required,
        rules,
        group,
      }}
    >
      <select className={inputClassName}>
        {options.map((item, index) => {
          return (
            <option value={item.symbol} key={index}>
              {item.label}
            </option>
          );
        })}
      </select>
    </FormItem>
  );
}
